import type { UGSExperienceConfigQueryParam } from 'type-props/unguided-sheet';

import { BASE_URL_V2 } from 'constants/api';

import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'UGS_EXPERIENCE_CONFIG_GET',
  GET_SUCCESS: 'UGS_EXPERIENCE_CONFIG_GET_SUCCESS',
  GET_FAILURE: 'UGS_EXPERIENCE_CONFIG_GET_FAILURE',
};

export const get = actions.get(
  (_: never, queryParam: UGSExperienceConfigQueryParam) =>
    `${BASE_URL_V2}/students/sheet-attempt-leap-config/?${stringify(queryParam)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
